var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeRank2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bronze_rank_2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 23,
    width: 190,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.142 23H5v154h189.142V23z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bronze_rank_2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.155 26.249c-5.033-5.285-13.767-3.915-16.984 2.639-8.407 17.104-5.793 38.349 8.112 52.959 17.355 18.228 45.887 19.41 64.674 3.028L40.155 26.25z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.484 61.45c-6.98-2.112-13.899 3.4-13.465 10.682 1.13 19.027 13.899 36.206 33.207 42.044 24.09 7.283 49.488-5.787 57.732-29.307l-77.474-23.42z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.56 104.976c-7.069 1.81-10.129 10.111-5.988 16.112 10.826 15.684 30.644 23.771 50.185 18.756 24.38-6.252 39.335-30.588 34.201-54.975L55.895 95.142l-38.328 9.828-.007.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.987 26.249c5.033-5.285 13.767-3.915 16.984 2.639 8.407 17.104 5.794 38.349-8.112 52.959-17.354 18.228-45.887 19.41-64.674 3.028l55.802-58.626z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.659 61.45c6.987-2.112 13.899 3.4 13.465 10.682-1.131 19.027-13.899 36.206-33.208 42.044-24.09 7.283-49.488-5.787-57.731-29.307l77.467-23.42h.007z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.582 104.976c7.068 1.81 10.128 10.111 5.988 16.112-10.827 15.684-30.644 23.771-50.186 18.756-24.379-6.252-39.333-30.588-34.2-54.975l40.063 10.273 38.328 9.828.007.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.059 27.957h101.91c6.089 0 11.04 4.946 11.04 11.04v76.008c0 34.215-27.779 61.995-61.992 61.995-34.213 0-61.992-27.78-61.992-61.995V38.998c0-6.089 4.945-11.04 11.04-11.04h-.006z",
    fill: "#CE7C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M64.51 53.771h71.015a7.69 7.69 0 017.69 7.691v46.531c0 23.84-19.359 43.2-43.198 43.2s-43.198-19.36-43.198-43.2v-46.53a7.691 7.691 0 017.69-7.692z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.525 56.285a5.186 5.186 0 015.177 5.177v46.531c0 22.432-18.253 40.686-40.685 40.686-22.431 0-40.685-18.254-40.685-40.686v-46.53a5.186 5.186 0 015.178-5.178h71.015zm0-2.514H64.51a7.691 7.691 0 00-7.691 7.691v46.531c0 23.859 19.34 43.2 43.198 43.2s43.198-19.341 43.198-43.2v-46.53a7.69 7.69 0 00-7.69-7.692z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.793 27.957l-32.768 32.77v48.635l81.395-81.404H70.793zM95.129 95.928l64.166-64.169c-2.024-2.325-4.996-3.802-8.32-3.802h-15.438l-54.188 54.19 13.78 13.78z",
    fill: "#fff",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeRank2);
export default ForwardRef;